/* eslint no-eval: 0 */

import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import React, { Fragment, useEffect, useState } from 'react';
//style={{ color: 'purple' }}
import { Datagrid, FunctionField, List, ShowButton, TextField } from 'react-admin';
import ResetViewsButton from '../bulk/ResetViewsButton';
import FormDialogPayement from '../dialog/FormDialogPayement.js';
import FiltreChargement from '../filtres/FiltreChargement';
//import ExportAgExp from './ExportAgExp';
import PostPagination from '../paginations/pagination';
import { has_role } from '../references';
import { isSelectable } from '../references.js';
import rowStyleChargement from '../styles/rowStyleChargement';

const  ListChargement=(props)=>{

    const [fullname, setFullname] = useState('');
    const [reste_a_payer, setReste_a_payer] = useState();
    const {permissions}=props;
    useEffect(() => {
        setFullname(localStorage.getItem('fullname'));
    }, []);

 return(
        <List {...props} 
                bulkActionButtons={<PostBulkActionButtons reste_a_payer={reste_a_payer} roles={permissions}/>}
                // actions={<ListActions/>}
                filters={<FiltreChargement type={has_role(permissions,'ROLE_AG_EXP_AERIEN_FR') ? 'AERIEN': 'AERIEN_DE_CNKRY'} />} 
                filterDefaultValues={has_role(permissions,'ROLE_AG_EXP_AERIEN_FR') ? {"camp_type":"AERIEN"}: {"camp_type":"AERIEN_DE_CNKRY"}} 
                pagination={<PostPagination {...props} />}
                sort={{ field: 'id', order: 'DESC' }}
                title={'Chargement - '+fullname}
                empty={false}
            >
                
            <Datagrid rowStyle={rowStyleChargement} isRowSelectable={record =>isSelectable(permissions,record.chge_user_id,record.camp_type) } >
                <TextField source="numCodeEtiq" label="Code" style={{ color: 'purple'  }} sortBy="numCodeEtiq"/>
                <TextField source="camp_type" label="Type" />
                <TextField source="fullname_exp" label="Expéditaire" sortBy="fullname_exp"/>
                <TextField source="fullname_dst" label="Destinataire" sortBy="fullname_dst"/>
                <TextField source="message" label="Message" sortBy="message"/>
                
                {has_role(permissions,'ROLE_MANAGER') ? null: 
                    <FunctionField render={record => <ShowButton  basePath={'/aerien/'+record.ord_id+'/show'}  label="Afficher" record={record} /> } />
                }
                <FunctionField render={record =>(record.reste_a_payer) ?  <FormDialogPayement from="list" for='livraison' data={record}/> :  null } />
                <FunctionField render={record => setReste_a_payer(record.reste_a_payer) } />
            </Datagrid>
        </List>
       ) ;
    };

export default ListChargement;

const PostBulkActionButtons = props => (
    <Fragment>
         <ResetViewsButton label={has_role(props.roles,'ROLE_MANAGER') ? 'Annuler chargement':'Chargé'}
            title={has_role(props.roles,'ROLE_MANAGER') ? 'Annuler chargement des colis séléctionnés':'Chargement des colis séléctionnés'}
            content={has_role(props.roles,'ROLE_MANAGER') ?'Voulez vous annuler le chargement des colis séléctionnés ?':'Voulez vous charger les colis séléctionnés ?'} {...props} 
            url={process.env.REACT_APP_URL +'/etiq/updateChgEtiqAerienMaritime?ids=' + props.selectedIds}
            startIcon={<HourglassEmptyIcon/>}
        />
    </Fragment>
);